import * as scales from 'd3-scale';
import capitalize from 'lodash.capitalize';

/**
 Return the scale type for a given key.
 @param {String} [key='linear'] - The scale type key.
 @return {Object} The scale type.
 */
function getScaleType(key = 'linear') {
  return scales[`scale${capitalize(key)}`];
}

export default getScaleType;
